const afrikaans = {
    'No official CAPS source was available for this request. Review curriculum coverage before using this content.': 'Geen amptelike KABV-bron was vir hierdie versoek beskikbaar nie. Kontroleer die kurrikulumdekking voordat u hierdie inhoud gebruik.',
    'PDF pages': 'PDF-bladsye',
    'Curriculum sources': 'Kurrikulumbronne', 'Retrieved': 'Afgelaai',
    'Review against your current ATP and applicable CAPS amendments before use.': 'Kontroleer teen u huidige jaarlikse onderrigplan en toepaslike KABV-wysigings voor gebruik.',
    'Assessment': 'Assessering', 'Test': 'Toets', 'Worksheet': 'Werkkaart',
    'Grade': 'Graad', 'GRADE': 'GRAAD', 'TERM': 'KWARTAAL',
    'marks': 'punte', 'Marks': 'Punte', 'MARKS': 'PUNTE', 'Total': 'Totaal', 'TOTAL': 'TOTAAL',
    'TIME': 'TYD', 'Time': 'Tyd', 'DIFFICULTY': 'MOEILIKHEIDSGRAAD',
    'Core': 'Kern', 'Support': 'Ondersteuning', 'Extension': 'Uitbreiding',
    'SCHOOL NAME:': 'SKOOLNAAM:', 'CLASS:': 'KLAS:', 'SURNAME:': 'VAN:', 'NAME:': 'NAAM:', 'DATE:': 'DATUM:',
    'MARKS OBTAINED': 'PUNTE BEHAAL', 'MARKSURE ASSESSMENT': 'MARKSURE ASSESSERING', 'MARKSURE WORKSHEET': 'MARKSURE WERKKAART',
    'Learner paper': 'Leerdervraestel', 'Learner worksheet': 'Leerderwerkkaart',
    'INSTRUCTIONS TO THE LEARNER': 'INSTRUKSIES AAN DIE LEERDER',
    'The test starts on the next page.': 'Die toets begin op die volgende bladsy.',
    'LEARNER TEST': 'LEERDERTOETS', 'LEARNER WORKSHEET': 'LEERDERWERKKAART',
    'END OF LEARNER PAPER': 'EINDE VAN LEERDERVRAESTEL', 'END OF LEARNER WORKSHEET': 'EINDE VAN LEERDERWERKKAART',
    'Memorandum': 'Memorandum', 'MEMORANDUM AND MARKING GUIDELINES': 'MEMORANDUM EN NASIENRIGLYNE',
    'Answer / solution': 'Antwoord / oplossing', 'Marking guideline': 'Nasienriglyn', 'Final answer': 'Finale antwoord',
    'MARKING MATRIX': 'NASIENMATRIKS', 'Question': 'Vraag', 'Topic / focus': 'Onderwerp / fokus',
    'Cognitive level': 'Kognitiewe vlak', 'Target': 'Teiken', 'distribution': 'verspreiding', 'TEACHER NOTES': 'ONDERWYSERNOTAS',
    'Knowledge': 'Kennis', 'Routine procedures': 'Roetineprosedures', 'Complex procedures': 'Komplekse prosedures', 'Problem solving': 'Probleemoplossing',
    'Literal, remembering and understanding': 'Letterlik, onthou en verstaan',
    'Reorganisation and application': 'Herorganisasie en toepassing',
    'Evaluation, appreciation and higher order': 'Evaluering, waardering en hoërorde-denke',
    'CAPS cognitive levels for non-language subjects': 'KABV-kognitiewe vlakke vir nie-taalvakke',
    'CAPS language cognitive levels': 'KABV-kognitiewe vlakke vir tale',
    'Actual': 'Werklik', 'Source': 'Bron',
    'CAPS Mathematics cognitive levels': 'KABV-kognitiewe vlakke vir Wiskunde',
    'CAPS language cognitive levels (Barrett)': 'KABV-kognitiewe vlakke vir tale (Barrett)',
    'Literal and reorganisation (Levels 1-2)': 'Letterlik en herorganisasie (vlakke 1-2)',
    'Inference (Level 3)': 'Afleiding (vlak 3)',
    'Evaluation and appreciation (Levels 4-5)': 'Evaluering en waardering (vlakke 4-5)',
    'Lower order': 'Laer orde', 'Middle order': 'Middelorde', 'Higher order': 'Hoër orde',
    'Not drawn to scale': 'Nie volgens skaal geteken nie'
};

export function assessmentTranslator(language) {
    return (text) => language === 'Afrikaans' ? (afrikaans[text] ?? text) : text;
}
